import { Subject } from 'rxjs';


export class StateHandlerService {

  
   dealers=new Subject();
  dealers$ = this.dealers.asObservable();

   controls=new Subject();
  controls$ = this.controls.asObservable();

   progressLineInfo = new Subject();
  progressLineInfo$ = this.progressLineInfo.asObservable();

   statusSubmit=new Subject();
  statusSubmit$ = this.statusSubmit.asObservable();

  constructor() {

    if (typeof( StateHandlerService.instance) === "object")
    return StateHandlerService.instance

    StateHandlerService.instance = this;
    return this;

   }

  publishDealers(data) {
    this.dealers.next(data);
  }
  publishControls(data) {
    this.controls.next(data);
  }
  publishProgressLineInfo(data){
    this.progressLineInfo.next(data);
  }
  publishStatusSubmit(data){
    this.statusSubmit.next(data)
  }
 
}
